'use client';

import { useModalStore } from '@/store/modal/modalStore';
import { BaseModal } from './BaseModal';
import React, { useEffect } from 'react';
import type { ModalEntry } from '@/store/modal/modalStore';

export const ModalManager: React.FC = () => {
  const { modals, closeModal } = useModalStore();

  // Блокировка скролла body при открытых модальных окнах
  useEffect(() => {
    if (modals.length > 0) {
      // сохраняем текущий стиль overflow, чтобы вернуть потом
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';

      return () => {
        document.body.style.overflow = originalOverflow;
      };
    }
  }, [modals.length]);

  return (
    <>
      {modals.map(({ id, component: Component, props }: ModalEntry) => {
        const maybeTitle = props.title;
        const title = typeof maybeTitle === 'string' ? maybeTitle : undefined;

        return (
          <BaseModal
            key={id}
            isOpen={true}
            onCloseAction={() => closeModal(id)}
            title={title}
          >
            <Component {...props} onCloseAction={() => closeModal(id)} />
          </BaseModal>
        );
      })}
    </>
  );
};
